/**
 * Widget graphique multi-courbes (Recharts) pour comparer les températures de plusieurs bâtiments.
 */
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Select } from "../../../common/Select";
import { WidgetShell } from "./WidgetShell";

export type ChartWidgetProps = {
  title?: string;
  periodLabel?: string;
};

const CHART_DATA = [
  { time: "00:00", b1: 32, b3: 30, b4: 28 },
  { time: "04:00", b1: 31, b3: 29, b4: 27 },
  { time: "08:00", b1: 33, b3: 31, b4: 29 },
  { time: "12:00", b1: 35, b3: 33, b4: 31 },
  { time: "16:00", b1: 36, b3: 34, b4: 32 },
  { time: "20:00", b1: 35, b3: 33, b4: 30 },
  { time: "24:00", b1: 34, b3: 32, b4: 29 },
];

const SERIES = [
  { key: "b1", name: "Bâtiment 1", color: "#B71C52" },
  { key: "b3", name: "Bâtiment 3", color: "#09a509" },
  { key: "b4", name: "Bâtiment 4", color: "#0976a5" },
] as const;

export const ChartWidget = ({
  title = "Température (°C)",
  periodLabel = "Aujourd'hui",
}: ChartWidgetProps) => {
  return (
    <WidgetShell
      title={title}
      detailRoute="/recharts"
      action={
        <Select size="compact" className="min-w-[8rem]" defaultValue="today">
          <option value="today">{periodLabel}</option>
          <option value="week">7 jours</option>
        </Select>
      }
    >
      <div className="h-full min-h-[200px] flex flex-col">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={CHART_DATA}
            margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
          >
            <CartesianGrid stroke="#E6E6E6" strokeDasharray="3 3" />
            <XAxis dataKey="time" tick={{ fontSize: 11 }} stroke="#939393" />
            <YAxis
              domain={[20, 40]}
              tick={{ fontSize: 11 }}
              stroke="#939393"
              width={32}
            />
            <Tooltip />
            {SERIES.map((s) => (
              <Line
                key={s.key}
                type="monotone"
                dataKey={s.key}
                name={s.name}
                stroke={s.color}
                strokeWidth={2}
                dot={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
        <div className="flex flex-wrap justify-center gap-4 mt-2 text-xs text-grey-medium">
          {SERIES.map((s) => (
            <span key={s.key} className="flex items-center gap-1.5">
              <span
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: s.color }}
              />
              {s.name}
            </span>
          ))}
        </div>
      </div>
    </WidgetShell>
  );
};
